import React from "react";
import { useDispatch } from "react-redux";
import { useQueryParams } from "../hoc/with-query-params";
import objectToQueryString from "modules/object-to-query-string";
import { changeWorkingSort, navigateToSort } from "actions/products-actions";
import RtrPill from "components/design-system/rtr-pill";
import classnames from "classnames";
import ActionLogger from "action-logger";

export type SortPillsProps = {
  onChangeSort: () => void;
  pillValues: Record<string, string>;
  sort: string;
};

const SortPills = ({ pillValues, onChangeSort = () => {}, sort }: SortPillsProps) => {
  const dispatch = useDispatch();
  const { queryParams } = useQueryParams();

  const changeSort = (newSort: string) => {
    const newParams = {
      ...queryParams,
      sort: newSort,
    };
    const path = window.location.pathname + "?" + objectToQueryString(newParams);

    ActionLogger.logAction({
      object_type: "grid",
      action: "grid_sort",
      sort_type: newSort,
      sort_type_from: sort,
    });

    dispatch(changeWorkingSort(newSort));
    //Ruby
    dispatch(navigateToSort(path));
    //Next
    onChangeSort();
  };

  const renderSortPill = (value: string, label: string) => {
    const onClick = () => changeSort(value);
    const isSelected = sort === value;

    const classes = classnames("border", "border-solid", "whitespace-nowrap", {
      "border-black": !isSelected,
      "border-wine bg-wine100": isSelected,
    });

    return (
      <RtrPill
        key={value}
        onClick={onClick}
        text={label}
        className={classes}
        dataTestId={isSelected ? "selected" : ""}
      />
    );
  };

  const renderSortPills = () => {
    return (
      <div className="flex justify-start md:flex-wrap overflow-scroll scrollbar-hidden">
        {Object.entries(pillValues).map(pill => renderSortPill(...pill))}
      </div>
    );
  };

  return (
    <div>
      <p className="my-2 text-lg">Sort by:</p>
      {renderSortPills()}
    </div>
  );
};

export default SortPills;
